import React from 'react';

const About = () => {
  return (
    <div className="panel-style text-[var(--text3-color)] text-sm container mx-auto p-4 max-w-3xl">
      {/* Fun header with sparkles */}
      <div className="text-center mb-6">
        <h1 className="text-4xl font-bold text-[var(--cute-headings)] mb-2">
          ~* About Pixelore *~
        </h1>
        <div className="flex justify-center gap-2 text-yellow-300">
          <span className="fa fa-sparkles"></span>
          <span className="fa fa-sparkles"></span>
          <span className="fa fa-sparkles"></span>
        </div>
      </div>

      {/* Profile card */}
      <div className="bg-[var(--entity-bg-color)] border-4 border-purple-300 rounded-xl p-6 mb-6 shadow-lg transform hover:rotate-1 transition-transform">
        <div className="flex flex-col md:flex-row items-center gap-6">
          <img 
            src="https://pixelore.s3.eu-central-003.backblazeb2.com/Avis/pixelore+pondering.jpeg"
            alt="Pixelore pondering" 
            className="w-40 h-40 object-cover rounded-full border-4 border-blue-300 shadow-md"
          />
          <div className="text-left">
            <div className="text-2xl font-bold text-[var(--cute-headings)] mb-2">Pixelore's Stats</div>
            <div className="grid grid-cols-2 gap-2 text-sm text-[var(--text-color)]">
              <p><span className="font-bold">Level:</span> 99 Cuteness</p>
              <p><span className="font-bold">Class:</span> Wiki Wizard</p>
              <p><span className="font-bold">HP:</span> ∞ Coffee</p>
              <p><span className="font-bold">MP:</span> 100% Pixels Knowledge</p>
              <p><span className="font-bold">Alignment:</span> Chaotic Helpful</p>
              <p><span className="font-bold">Birthday:</span> August 10</p>
            </div>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="space-y-6">
        {/* About section */}
        <div className="bg-blue-100 border-2 border-blue-200 rounded-lg p-5">
          <h2 className="text-xl font-bold text-blue-700 mb-3 flex items-center gap-2">
            <span className="fa fa-heart text-red-400"></span> Who dis?
          </h2>
          <p className="mb-3 about-me-paragraph">
            Just a Pixel-obsessed bean who spends way too much time in Terra Villa! (◕‿◕✿)
          </p>
          <p className="about-me-paragraph">
            I'm not a pro gamer, just a passionate nerd who loves sharing Pixels knowledge! 
            My wiki updates might be irregular but they're made with love~ (ﾉ◕ヮ◕)ﾉ*:･ﾟ✧
          </p>
        </div>

        {/* Contact section */}
        <div className="bg-green-100 border-2 border-green-200 rounded-lg p-5">
          <h2 className="text-xl font-bold text-green-700 mb-3 flex items-center gap-2">
            <span className="fa fa-comment-dots text-green-500"></span> Chat with me!
          </h2>
          <p className="mb-2 about-me-paragraph">
            Hit me up on <a href="https://twitter.com/yourhandle" className="text-blue-500 underline">Twitter</a> for:
          </p>
          <ul className="list-disc pl-5 space-y-1 about-me-paragraph">
            <li>Game questions (no ban/bug reports pls)</li>
            <li>Wiki suggestions</li>
            <li>Random Pixels thoughts</li>
            <li>Pet pictures (always welcome)</li>
          </ul>
        </div>

        {/* Collab section */}
        <div className="bg-yellow-100 border-2 border-yellow-200 rounded-lg p-5">
          <h2 className="text-xl font-bold text-yellow-700 mb-3 flex items-center gap-2">
            <span className="fa fa-handshake text-yellow-500"></span> Let's collab!
          </h2>
          <p className="mb-3 about-me-paragraph">
            Want to work together on something Pixels-related? I'm down for:
          </p>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="bg-white bg-opacity-50 p-3 rounded-lg">
              <h3 className="font-bold mb-1 flex items-center gap-1">
                <span className="fa fa-pencil-alt text-purple-400"></span> Creative Stuff
              </h3>
              <ul className="text-sm space-y-1 about-me-paragraph">
                <li>• Fan art trades</li>
                <li>• Meme collaborations</li>
                <li>• Silky shenanigans</li>
              </ul>
            </div>
            <div className="bg-white bg-opacity-50 p-3 rounded-lg">
              <h3 className="font-bold mb-1 flex items-center gap-1">
                <span className="fa fa-code text-blue-400"></span> Techy Things
              </h3>
              <ul className="text-sm space-y-1 about-me-paragraph">
                <li>• Cool wiki features</li>
                <li>• Integrations</li>
                <li>• Helpful ideas!</li>
              </ul>
            </div>
          </div>
          <p className="mt-3 text-sm about-me-paragraph">
            (Serious or silly projects both welcome! ヽ(•̀ω•́ )ゝ✧)
          </p>
        </div>

        {/* Support section */}
        <div className="bg-purple-100 border-2 border-purple-200 rounded-lg p-5 text-center">
          <h2 className="text-xl font-bold text-purple-700 mb-2 flex items-center justify-center gap-2">
            <span className="fa fa-coffee text-brown-500"></span> Support the Wiki
          </h2>
          <p className="mb-2 about-me-paragraph">
            Running this site costs real money (｡•́︿•̀｡) 
          </p>
          <p className="font-bold text-purple-600">
            If you enjoy the wiki, consider supporting me: <span className="underline">pixelore.ron</span>
          </p>
          <p className="text-sm mt-1 about-me-paragraph">
            (Even small amounts help keep the lights on! (ᵔᴥᵔ))
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;